import UseTemplateButton from './UseTemplateButton';

export default UseTemplateButton;
